//  ----------      START   IMPORT  BLOCK       ----------
import { useState, useEffect } from 'react';
//  Widgets
import { Button, } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
//  Context
import { useLanguage } from '../../API/Context/LanguageContext';
//  Config
import VocabTopBar from '../../ConfigFiles/multilingual/VocabTopBar';
import '../TopBar/TopBar.css'
//  ----------      END   IMPORT  BLOCK       ----------


/**
 * MedicSearchBar Component for user/username search.
 * @param {object} props - Component props.
 * @param {function} props.onSearch - Callback function to execute the search.
 */
const MedicSearchBar = ({ onSearch, initialValue = '' }) => {
  const { lan } = useLanguage();
  const [searchUser, setSearchUser] = useState('');
  // 'shake' state is used for visual feedback on empty submission
  const [shake, setShake] = useState(false); 

  useEffect(() => {
    setSearchUser(initialValue);
  }, [initialValue]);
  
  // Handler for form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (searchUser.trim() === '') {
      // Trigger shake animation for validation
      setShake(true);
      setTimeout(() => setShake(false), 500);
      return;
    }
    // Execute the search function passed from props
    onSearch(searchUser.trim());
  };

  return (
    <Form className="" onSubmit={handleSubmit}>
      <InputGroup className="mb-3">
        {/* Input Field */}
        <Form.Control
          placeholder={lan === 0 ? 'Buscar por nombre de usuario' : 'Search by username'}
          value={searchUser}
          onChange={(e) => setSearchUser(e.target.value)}
          className={`${shake ? 'shake' : ''}`}
        />
        {/* The button uses the 'btn-sm' utility class for a compact look. */}
        <Button type="submit" variant="outline-secondary" className={`${shake ? 'shake' : ''}`}>
          {VocabTopBar.search[lan]}
        </Button>
      </InputGroup>
    </Form>
  );
};

export default MedicSearchBar;